import { useApi } from '@omnipresentgroup/api';
import type { GetReportingFlagsResponseAPI } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformReportingFlagsFromAPI } from '../mappers';

export const getReportingFlagsKey = (companyId: string) => [
  API_PATH,
  'reporting-flags',
  companyId,
];

export const useReportingFlags = ({
  companyId,
  enabled,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();
  const query = useQuery({
    queryKey: getReportingFlagsKey(companyId),
    queryFn: () =>
      GET<GetReportingFlagsResponseAPI>(
        `${API_BASE}/${API_PATH}/${companyId}`,
        {},
      ),
    select: (data) => transformReportingFlagsFromAPI(data),
    enabled: enabled || !!companyId,
    throwOnError: false,
  });

  return query;
};
